import { api } from "./api";

export async function getBillingSettings() {
  const { data } = await api.get("/billing/settings");
  return data;
}
export async function saveBillingSettings(payload) {
  const { data } = await api.put("/billing/settings", payload);
  return data;
}
export async function testBillingConnection() {
  const { data } = await api.post("/billing/test-connection");
  return data;
}
export async function listInvoices(params = {}) {
  const { data } = await api.get("/billing/invoices", { params });
  return data;
}
export async function getInvoice(id) {
  const { data } = await api.get(`/billing/invoices/${id}`);
  return data;
}
export async function getBillingKpis() {
  const { data } = await api.get("/billing/kpis");
  return data;
}
export async function issueInvoiceForOrder(orderId, body = {}) {
  const { data } = await api.post(`/billing/orders/${orderId}/issue-invoice`, body);
  return data;
}
export async function cancelInvoice(id) {
  const { data } = await api.post(`/billing/invoices/${id}/cancel`);
  return data;
}
export async function getInvoiceForOrder(orderId) {
  const { data } = await api.get(`/billing/orders/${orderId}/invoice`);
  return data.invoice || null;
}
export function invoicePdfUrl(invoiceId) {
  // Build a tokenized URL so the iframe / <a download> can stream the PDF.
  const base = process.env.REACT_APP_BACKEND_URL;
  const token = localStorage.getItem("token");
  return `${base}/api/billing/invoices/${invoiceId}/pdf?token=${encodeURIComponent(token || "")}`;
}

export async function fetchInvoicePdfBlob(invoiceId) {
  const resp = await api.get(`/billing/invoices/${invoiceId}/pdf`, { responseType: "blob" });
  return resp.data;
}

export async function refreshInvoiceStatus(invoiceId) {
  const { data } = await api.post(`/billing/invoices/${invoiceId}/refresh-status`);
  return data;
}

export async function refreshAllInvoices(limit = 200) {
  const { data } = await api.post(`/billing/refresh-all`, null, { params: { limit } });
  return data;
}

// Open the invoice in SmartBill web UI. The hash-routed URL pattern works for
// authenticated SmartBill Cloud sessions; if the user isn't logged in, SmartBill
// will redirect them to login and keep the deep-link.
export function smartbillWebUrl(invoice) {
  if (!invoice?.series_name || !invoice?.number) return "https://cloud.smartbill.ro/";
  return `https://cloud.smartbill.ro/factura/${encodeURIComponent(invoice.series_name)}${encodeURIComponent(invoice.number)}`;
}
